import type { Theme } from "@mui/material/styles"
import { colors, type ViraPalette } from "./tokens"

/**
 * Returns `theme.palette.vira` when the tree is wrapped in `ViraThemeProvider`,
 * otherwise falls back to light-mode tokens so vira-ui atoms work under legacy
 * MUI `ThemeProvider` (e.g. Client Detail when `vira_loop` is off).
 */
export function resolveViraPalette(theme: Theme): ViraPalette {
  return theme.palette.vira ?? colors.vira
}
